import { staticContentAxios as axios } from './configuration/axiosConfig';
import { ClientResponse } from '../model/types/ClientResponse';

export const getYearList = async (): Promise<ClientResponse<string[]>> => {
  const { data, status } = await axios.get('static/SK/ZZ/list.json');

  let mappedData: string[];
  if (data === null) {
    mappedData = [];
  } else {
    mappedData = data.rok;
  }

  return {
    data: mappedData,
    responseCode: status,
  };
};
